import { render, staticRenderFns } from "./CalendarMonthEvent.vue?vue&type=template&id=5c555040"
import script from "./CalendarMonthEvent.vue?vue&type=script&lang=js"
export * from "./CalendarMonthEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports